module.exports = require("react-collapse");


/*****************
 ** WEBPACK FOOTER
 ** external "react-collapse"
 ** module id = 77
 ** module chunks = 0
 **/